export default __webpack_public_path__ + "static/media/available.3c9097d2.svg";